import React from "react";
import "../styles/Home.css";

import welcomeImg from "../assets/img/welcome.png";
import studentImg from "../assets/img/student.jpeg";
import youtubeImg from "../assets/img/youtube.jpeg";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
const Home = () => {
  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <a className="navbar-brand fw-bold" href="#">
           <img src={logo} className="img-fluid"/> AI Tools Benefits
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#nav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="nav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="#">Home</a></li>
              <li className="nav-item"><a className="nav-link" href="#">Courses</a></li>
              <li className="nav-item"><a className="nav-link" href="#">Blog</a></li>
              <li className="nav-item"><a className="nav-link" href="#">Contact</a></li>
              <li className="nav-item ms-3">
                <Link to="login" className="btn btn-main">login</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero royal-blue-gradient">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1>
                Supercharge Your Studies & <br />
                YouTube Channel with{" "}
                <span className="text-warning">AI Tools</span>
              </h1>
              <p>
                Boost your productivity and grow your YouTube channel with the
                power of AI!
              </p>

            <Link to="/exploreAICourses"> 
             <button className="btn btn-success me-3">Explore AI Courses</button>
              </Link>
               <Link to="/ExploreYouTubeTools"> 
              <button className="btn btn-warning">500+ best Ai tools list for us</button>
               </Link>
            </div>

            <div className="col-lg-6 text-center">
              <img
                src={welcomeImg}
                alt="welcome"
                className="img-fluid"
                style={{ maxWidth: "380px" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* STUDENTS & YOUTUBERS */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">

            {/* STUDENTS */}
            <div className="col-md-6">
              <div className="big-card student-bg">
                <h4>For Students <small>/ छात्रों के लिए</small></h4>
                <img src={studentImg} className="img-fluid rounded mt-2" />

                <div className="row g-3 mt-3">
                  <div className="col-sm-6">
                    <div className="inner-card">
                      <h6>AI Study Assistants</h6>
                      <p>AI help for homework & exams.</p>
                    <Link to="/AIStudyAssistants" className="learn-btn">Learn More →</Link>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="inner-card">
                      <h6>AI Note-Taking</h6>
                      <p>Convert lectures into notes.</p>
                      <Link to="/AINoteTaking" className="learn-btn">Learn More →</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* YOUTUBERS */}
            <div className="col-md-6">
              <div className="big-card youtuber-bg">
                <h4>For YouTubers <small>/ यूट्यूबर्स के लिए</small></h4>
                <img src={youtubeImg} className="img-fluid rounded mt-2" />

                <div className="row g-3 mt-3">
                  <div className="col-sm-6">
                    <div className="inner-card">
                      <h6>AI Content Ideas</h6>
                      <p>Viral content ideas.</p>
                        <Link to="/AIContentIdeas" className="learn-btn">Learn More →</Link>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="inner-card">
                      <h6>AI Video Editing</h6>
                      <p>Smart AI video tools.</p>
                        <Link to="/AIVideoEditing" className="learn-btn">Learn More →</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY AI */}
      <section className="py-5 bg-light">
        <div className="container">
          <h3 className="text-center fw-bold mb-4">Why Use AI Tools?</h3>

          <div className="row g-4">
            {[
              ["clock", "Save Time", "Complete tasks faster."],
              ["star", "Improve Quality", "Better results."],
              ["chart-line", "Grow Faster", "Quick growth."],
              ["wallet", "Earn More", "Increase income."],
              ["layer-group", "Use More", "More tools."],
              ["bolt", "Increase Lives", "Smart work."]
            ].map((item, i) => (
              <div className="col-md-4" key={i}>
                <div className="why-box">
                  <div className="why-icon">
                    <i className={`fa fa-${item[0]}`}></i>
                  </div>
                  <div>
                    <h6>{item[1]}</h6>
                    <p>{item[2]}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* REVIEWS */}
      <section className="py-5">
        <div className="container">
          <h3 className="text-center fw-bold mb-4">
            Student & YouTuber Reviews
          </h3>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="review-box d-flex gap-3 justify-content-center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  width="60"
                  className="rounded-circle"
                />
                <div>
                  <h6>Sarthak Gupta</h6>
                  <div className="star">★★★★★</div>
                  <p>AI tools helped me clear exams.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="review-box d-flex gap-3">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/4140/4140048.png"
                  width="60"
                  className="rounded-circle"
                />
                <div>
                  <h6>Nidhi Sharma</h6>
                  <div className="star">★★★★★</div>
                  <p>My channel grew faster.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* FOOTER */}
 <footer className="footer bg-dark text-light pt-5">
  <div className="container">
    <div className="row">

      <div className="col-md-3 mb-4">
        <h6 className="footer-title fw-bold">Quick Links</h6>
        <a href="#" className="text-light d-block">Terms & Services</a>
        <a href="#" className="text-light d-block">YouTube Tools</a>
      </div>

      <div className="col-md-3 mb-4">
        <h6 className="footer-title fw-bold">Courses</h6>
        <a href="#" className="text-light d-block">AI Courses</a>
        <a href="#" className="text-light d-block">YouTube Growth</a>
      </div>

      <div className="col-md-3 mb-4">
        <h6 className="footer-title fw-bold">Blog</h6>
        <a href="#" className="text-light d-block">Learn Secrets</a>
        <a href="#" className="text-light d-block">Privacy Policy</a>
      </div>

   <div className="col-md-3 mb-4">
  <h6 className="footer-title fw-bold">Contact</h6>

  <p className="mb-1">
    📞 <a href="tel:7724082084" className="text-light text-decoration-none">
      7724082084
    </a>
  </p>

  <p className="mb-1">
    ✉️ <a href="mailto:sanketsinghdangi74@gmail.com" className="text-light text-decoration-none">
      sanketsinghdangi74@gmail.com
    </a>
  </p>

  <a
    href="https://www.instagram.com/aitoolsbenefits?igsh=MW0yOHV6MjZxdXFnZA=="
    target="_blank"
    rel="noreferrer"
    className="text-light d-block text-decoration-none"
  >
    📸 Instagram: @aitoolsbenefits
  </a>
</div>


    </div>

    

    <div className="footer-bottom d-flex justify-content-between align-items-center pb-3">
      <p className="mb-0">© 2025 AI Tools Benefits</p>
      {/* <div className="social-icons fs-4">
        <i className="bi bi-facebook me-3"></i>
        <i className="bi bi-instagram me-3"></i>
        <i className="bi bi-youtube"></i>
      </div> */}
    </div>

  </div>
</footer>

    </>
  );
};

export default Home;
